<template>
    <div class="s-nice-text" v-if="profile">
        <div class="o-layout">
            <div class="o-layout__item  u-4/12  u-12/12@sm">
                <img :src="profile.photo ? $root.pUrl + profile.photo : '/images/no-image.jpg'" alt=""
                     class="u-12/12  u-margin-bottom">
            </div>
            <div class="o-layout__item  u-8/12  u-12/12@sm">
                <h2>{{ profile.name }}</h2>
                <div v-html="profile.introLong || profile.introSho"></div>
            </div>

        </div>

        <div class="o-layout  o-layout--right" v-if="profile.topics.length > 0">
            <div class="o-layout__item  u-10/12  u-12/12@md">
                <div class="c-separator  c-separator--nice  u-margin-bottom  u-padding-top"></div>
            </div>
        </div>

        <div class="o-layout  o-layout--right" v-if="profile.topics.length > 0">
            <div class="o-layout__item  u-2/12  u-3/12@md  u-12/12@sm">
                <div class="s-nice-text__mid-title">{{ marxism.title }}에서 연설할 주제</div>
            </div>
            <div class="o-layout__item  u-8/12  u-9/12@md  u-12/12@sm">
                <ul>
                    <li v-for="topic of profile.topics">
                        <p class="s-nice-text__normal">
                            <b class="u-text-tiny" v-if="topic.subtitleTop">{{ topic.subtitleTop }}</b>
                            <topic-title :topic="topic" :isLink="!!topic.introLong"/>
                            <b class="u-text-tiny" v-if="topic.subtitleBottom">{{ topic.subtitleBottom }}</b>
                        </p>
                        <p v-if="showTopicMeta(topic)">
                         <span v-if="topic.hideTime === 'n'">
                             {{ readableTime(topic.startTime) }} - {{ justTime(topic.endTime) }}
                         </span>
                            <span class="c-nice-pipe-symbol" v-if="topic.hideLocation === 'n' && topic.location"></span>
                            {{ topic.location }}
                        </p>
                    </li>
                    <li v-if="profile.id === 1087">
                        <p class="s-nice-text__normal">
                            <b class="u-text-tiny" v-if="marxism.topics[9231].subtitleTop">{{
                                marxism.topics[9231].subtitleTop }}</b>
                            {{ marxism.topics[9231].title }}
                            <b class="u-text-tiny" v-if="marxism.topics[9231].subtitleBottom">{{
                                marxism.topics[9231].subtitleBottom }}</b>
                        </p>
                        <p v-if="showTopicMeta(marxism.topics[9231])">
                             <span v-if="marxism.topics[9231].hideTime === 'n' && marxism.topics[9231].formattedDate">
                                 {{ marxism.topics[9231].formattedDate }}
                             </span>
                            <span class="c-nice-pipe-symbol"
                                  v-if="marxism.topics[9231].hideLocation === 'n' && marxism.topics[9231].location"></span>
                            {{ marxism.topics[9231].location }}
                        </p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Profile",
        props: ["profile", "marxism"],
        mixins: [require('./mixin')],
        data: () => {
            return {
                history: window.history
            }
        },
        mounted() {
            let pageTitle = this.profile.name;
            document.querySelector('title').innerText = `${pageTitle} | ${marxism.title} - 마르크스주의 포럼`;

            if (window.gtag) {
                // for google analytics page tracking
                window.gtag('config', 'UA-2193909-1', {
                    'page_title': `${pageTitle} | ${this.marxism.title} - 마르크스주의 포럼`,
                    'page_path': (new URL(location.href)).pathname
                });
            }
        },
	    methods: {
		    readableTime(hh_mm) {
			    if (moment(hh_mm, 'hh:mm').format('m') === '0') {
				    return moment(hh_mm, 'hh:mm').format('a h시');
			    } else {
				    return moment(hh_mm, 'hh:mm').format('a h시 m분');
			    }

		    },
		    justTime(hh_mm){
			    if(moment(hh_mm, 'hh_mm').format('m') === '0'){
				    return moment(hh_mm, 'hh:mm').format('h시');
			    }else{
				    return moment(hh_mm, 'hh:mm').format('h시 m분');
			    }
		    }
	    }

    }
</script>

<style scoped>

</style>
